module.exports = __webpack_public_path__ + "img/gs3.3389b29e.png";